/** Formatiranje novca. Backend šalje BigDecimal kao broj/string — uvek RSD. */

const rsdFormatter = new Intl.NumberFormat('sr-RS', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/**
 * @param {number|string} amount
 * @param {object} [options]
 * @param {boolean} [options.from] prefiks „od" kada proizvod ima varijante različitih cena
 */
export const formatPrice = (amount, { from = false } = {}) => {
  const value = typeof amount === 'number' ? amount : Number(amount);
  if (!Number.isFinite(value)) {
    return '';
  }
  return `${from ? 'od ' : ''}${rsdFormatter.format(value)} RSD`;
};

export default { formatPrice };
